import { render, staticRenderFns } from "./Transition.vue?vue&type=template&id=5280e733&scoped=true"
import script from "./Transition.vue?vue&type=script&lang=js"
export * from "./Transition.vue?vue&type=script&lang=js"
import style0 from "./Transition.vue?vue&type=style&index=0&id=5280e733&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5280e733",
  null
  
)

export default component.exports